module.exports = __webpack_public_path__ + "img/img_53@2x.13073235.png";